import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { getBenefitInfo } from 'src/utils/index';
import { BenefitsEnum, IBenefits } from 'src/common-types/index';
import './style.scss';

interface IProps {
  benefits: IBenefits;
}

const ZERO = 0;

export class CustomGetaways extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { benefits } = this.props;

    return (
      <div className="custom__getaway">
        <div className="getaway__container">
          <h2 className="custom__getaway_title">
            <FormattedMessage id="custom.getaway.title" />
          </h2>
          <div className="custom__getaway_list">
            {getBenefitInfo(benefits, BenefitsEnum.Getaways)[ZERO].childItems.map(
              ({ title, description, imageUrl, url }, index) => (
                <Link key={`${index}-${title}`} to={url} className="custom__getaway_item">
                  <img className="custom__getaway_item-img" src={imageUrl} alt={title} />
                  <div className="custom__getaway_item-info">
                    <p className="custom__getaway_item-info_title">{title}</p>
                    <p className="custom__getaway_item-info_subtitle">{description}</p>
                  </div>
                </Link>
              ),
            )}
          </div>
        </div>
      </div>
    );
  }
}
